import Vue from "vue";
import Router from "vue-router";
//import Splash from "@/views/Splash.vue"; 
import Public from "./views/Public.vue";
import Back from "./views/Back.vue";
import Login from "./views/Back/Login";
import ResetPassword from "./views/Back/ResetPassword";
import PasswordReset from "./views/Back/PasswordReset";
// Public Routes
import Index from "./views/Public/Pages/Index.vue";
import Reservation from "./views/Public/Pages/Reservation.vue";
import PFacility from "./views/Public/Pages/Facility.vue";
import PActivity from "./views/Public/Pages/Activity.vue";
import ActivitySelection from "./views/Public/Pages/ActivitySelection.vue";
import BookingInformation from "./views/Public/Pages/BookingInformation.vue";
import PaymentInformation from "./views/Public/Pages/PaymentInformation.vue";
import BookingSuccess from "./views/Public/Pages/BookingSuccess.vue";
import SupportUs from "./views/Public/Pages/SupportUs.vue";
import SupportPayment from "./views/Public/Pages/SupportPayment.vue";
import SuccessDonation from "./views/Public/Pages/SuccessDonation.vue";
import RegisterMember from "./views/Public/Pages/RegisterMember.vue";
import EditMember from "./views/Back/Membership/EditMember";
import EditCorporateMember from "./views/Back/Membership/EditCorporateMember";
// import MembershipPayment from './views/Public/Pages/MembershipPayment.vue'
import SuccessMembership from "./views/Public/Pages/SuccessMembership.vue";
import PVolunteerProgram from "./views/Public/Repeated/Programs.vue";
// new routes
import Program from "./views/Public/Pages/Program.vue";
import ProgramPayment from "./views/Public/Pages/ProgramPayment.vue";
import PTermsAndConditions from "./views/Public/Pages/TermsAndConditions.vue";
import disclaimer from "./views/Public/Pages/disclaimer.vue";
import SuccessVolunteer from "./views/Public/Pages/SuccessVolunteer.vue";
import PostponeBooking from "./views/Back/Bookings/PostponeBooking.vue";
import IveriPaymentFailure from "./views/Public/Pages/IveriPaymentFailure.vue";


Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
  // {
  //   path: "/",
  //   name: "Splash",
  //   component: Splash
  // },
    {
      path: "/",
      component: Public,
      children: [
        {
          path: "",
          name: "Index",
          component: Index
        },
        {
          path: "pt&c",
          name: "PTermsAndConditions",
          component: PTermsAndConditions
        },
        {
          path: "disclaimer",
          name: "disclaimer",
          component: disclaimer
        },
        {
          path: "program-payment/:program_id",
          name: "ProgramPayment",
          component: ProgramPayment,
          meta: { payment: true }
        },
        {
          path: "reservation",
          name: "Reservation",
          component: Reservation
        },
        {
          path: "facility/:facility_id",
          name: "PFacility",
          component: PFacility
        },
        {
          path: "activity/:activity_id",
          name: "PActivity",
          component: PActivity
        },
        {
          path: "activity-selection",
          name: "ActivitySelection",
          component: ActivitySelection
        },
        {
          path: "express-selection",
          name: "ExpressCheckout",
          component: ActivitySelection
        },
        {
          path: "express-booking-info",
          name: "ExpressBookingInformation",
          component: BookingInformation
        },
        {
          path: "booking-info",
          name: "BookingInformation",
          component: BookingInformation
        },
        {
          path: "express-payment-info",
          name: "ExpressPaymentInformation",
          component: PaymentInformation
        },
        {
          path: "payment/info/:booking_id",
          name: "PaymentInformation",
          component: PaymentInformation,
          meta: { payment: true }
        },
        {
          path: "support-us",
          name: "SupportUs",
          component: SupportUs
        },
        {
          path: "support-us-payment/:donation_id",
          name: "SupportPayment",
          component: SupportPayment,
          meta: { payment: true }
        },
        {
          path: "immersive-conservation-experiences",
          name: "VolunteerProgram",
          component: PVolunteerProgram
        },
        // patty
        {
          path: "immersive-conservation-experience/:program_id",
          name: "Program",
          component: Program
        },
        {
          path: "membership-registration",
          name: "RegisterMember",
          component: RegisterMember
        },
        {
          path: "membership-edit",
          name: "EditMember",
          component: EditMember
        },
        {
          path: "corporate_membership-edit",
          name: "EditCorporateMember",
          component: EditCorporateMember
        },
        {
          path: "membership-payment/:member_id",
          name: "NewMembershipPayment",
          // component: Member,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Public/Pages/NewMemberPayment"),
          meta: { payment: true }
        },
        {
          path: "membership-payment/:member_id",
          name: "MembershipPayment",
          // component: Member,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Public/Pages/MembershipPayment"),
          meta: { payment: true }
        },
        {
          path: "success/donation",
          name: "SuccessDonation",
          component: SuccessDonation
        },
        {
          path: "success/membership",
          name: "SuccessMembership",
          component: SuccessMembership
        },
        {
          path: "success/booking/:booking_id",
          name: "BookingSuccess",
          component: BookingSuccess
        },
        {
          path: "success/volunteer",
          name: "SuccessVolunteer",
          component: SuccessVolunteer
        },
        {
          path: "payment-failure/:booking_id",
          name: "IveriPaymentFailure",
          component: IveriPaymentFailure
        },
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: ResetPassword
    },
    {
      path: "/password/reset/:reset_id",
      name: "PasswordReset",
      component: PasswordReset
    },
    {
      path: "/",
      component: Back,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Dashboard.vue"),
          meta: { requiresAuth: true }
        },
                {
          path: "dashboard",
          name: "MyDashboard",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Dashboard.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "dashboard",
          name: "ConservationVehicleCalendar",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/ConservationVehicleCalendar.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "dashboard",
          name: "PendingPartnerBookings",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/PendingPartnerBookings.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "dashboard",
          name: "PendingGroupBookings",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/PendingSchoolBooking.vue"),
          meta: { requiresAuth: true }
        },
        // Settings
        {
          path: "sales-force",
          name: "SalesForce",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/SalesForce"),
          meta: { requiresAuth: true }
        },
        {
          path: "call-to-action",
          name: "CallToActions",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/CallToActions"),
          // component: CallToActions,
          meta: { requiresAuth: true }
        },
        {
          path: "conservation-fees",
          name: "ConservancyFees",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/ConservancyFees"),
          // component: ConservancyFees,
          meta: { requiresAuth: true }
        },
        {
          path: "add-page",
          name: "AddPage",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/Page"),
          // component: Page,
          meta: { requiresAuth: true }
        },
        {
          path: "extra-pages",
          name: "Pages",
          // component: Pages,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/Pages"),
          meta: { requiresAuth: true }
        },
        {
          path: "page/:page_id",
          name: "Page",
          // component: Page,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/Page"),
          meta: { requiresAuth: true }
        },
        {
          path: "page-types",
          name: "PageTypes",
          // component: PageTypes,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/PageTypes"),
          meta: { requiresAuth: true }
        },
        {
          path: "terms-and-conditions",
          name: "TermsAndConditions",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/TermsAndConditions"),
          // component: TermsAndConditions,
          meta: { requiresAuth: true }
        },
        {
          path: "vehicle-fees",
          name: "VehicleFees",
          // component: VehicleFees,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Settings/VehicleFees"),
          meta: { requiresAuth: true }
        },
        // Volunteer Programs
        {
          path: "volunteer-application/:applicant_id",
          name: "SingleVolunteerApplicant",
          // component: SingleVolunteerApplicant,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/VolunteerProgram/SingleVolunteerApplication"),
          meta: { requiresAuth: true }
        },
        {
          path: "edit-volunterr-program/:program_id",
          name: "EditProgram",
          // component: NewVolunteerProgram,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/VolunteerProgram/NewVolunteerProgram"),
          meta: { requiresAuth: true }
        },
        {
          path: "add-new-program",
          name: "NewVolunteerProgram",
          // component: NewVolunteerProgram,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/VolunteerProgram/NewVolunteerProgram"),
          meta: { requiresAuth: true }
        },
        {
          path: "all-programs",
          name: "VolunteerPrograms",
          // component: VolunteerPrograms,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/VolunteerProgram/VolunteerPrograms"),
          meta: { requiresAuth: true }
        },
        // patty
        {
          path: "m-program/:program_id",
          name: "MVolunteerProgram",
          // component: VolunteerProgram,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/VolunteerProgram/VolunteerProgram"),
          meta: { requiresAuth: true }
        },
        // {
        //   path: 'program-settings',
        //   name: 'VolunteerProgramSettings',
        //   component: VolunteerProgramSettings,
        //   meta: { requiresAuth: true }
        // },
        // Staff
        {
          path: "add-staff",
          name: "AddStaff",
          // component: AddStaff,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Staff/AddStaff"),
          meta: { requiresAuth: true }
        },
        {
          path: "edit-staff/:staff_id",
          name: "EditStaff",
          // component: AddStaff,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Staff/AddStaff"),
          meta: { requiresAuth: true }
        },
        {
          path: "all-staff",
          name: "AllStaff",
          // component: AllStaff,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Staff/AllStaff"),
          meta: { requiresAuth: true }
        },
        {
          path: "staff-settings",
          name: "StaffSettings",
          // component: StaffSettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Staff/StaffSettings"),
          meta: { requiresAuth: true }
        },
        // Calendar
        {
          path: "calendar",
          name: "Calendar",
          // component: Calendar,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Calendar"),
          meta: { requiresAuth: true }
        },
        // Users
        {
          path: "add-user",
          name: "AddUser",
          // component: AddUser,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/AddUser"),
          meta: { requiresAuth: true }
        },
        {
          path: "users",
          name: "Users",
          // component: Users,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/Users"),
          meta: { requiresAuth: true }
        },
        {
          path: "user-bookings/:user_id",
          name: "UserBookings",
          component: () =>
            import(/* webpackChunkName: "user-bookings" */ "./views/Back/Users/UserBookings"),
          meta: { requiresAuth: true }
        },
        {
  path: "user-wallet/:user_id",
  name: "UserWalletTransactions",
  component: () =>
    import(/* webpackChunkName: "user-wallet" */ "./views/Back/Users/UserWalletTransactions"),
  meta: { requiresAuth: true }
        },
        {
          path: "profile",
          name: "MyProfile",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/Profile"),
          meta: { requiresAuth: true }
        },
        {
          path: "user/:user_id",
          name: "User",
          // component: User,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/User"),
          meta: { requiresAuth: true }
        },
        {
          path: "user-types",
          name: "UserTypes",
          // component: UserTypes,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/UserTypes"),
          meta: { requiresAuth: true }
        },
        {
          path: "roles/:role_id",
          name: "Roles",
          // component: Roles,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/Roles"),
          meta: { requiresAuth: true }
        },
        {
          path: "features/:menu_id",
          name: "Features",
          // component: Features,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/Features"),
          meta: { requiresAuth: true }
        },
        {
          path: "public-users",
          name: "PublicUsers",
          // component: Users,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/PublicUsers"),
          meta: { requiresAuth: true }
        },
        {
          path: "public-user/:public_user_id",
          name: "PublicUser",
          // component: User,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Users/PublicUser"),
          meta: { requiresAuth: true }
        },
        // Doners
        {
          path: "add-doner",
          name: "AddDoner",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Doners/AddDoner"),
          // component: AddDoner,
          meta: { requiresAuth: true }
        },
        {
          path: "doner/:doner_id",
          name: "Doner",
          // component: Doner,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Doners/Doner"),
          meta: { requiresAuth: true }
        },
        {
          path: "doners",
          name: "Doners",
          // component: Doners,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Doners/Donners"),
          meta: { requiresAuth: true }
        },
        // Donations
        {
          path: "donations-causes",
          name: "DonationCauses",
          // component: Donations,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Donations/DonationSettings"),
          meta: { requiresAuth: true }
        },
        {
          path: "donations",
          name: "Donations",
          // component: Donations,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Donations/Donations"),
          meta: { requiresAuth: true }
        },
        {
          path: "donation/:donation_id",
          name: "Donation",
          // component: Donation,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Donations/Donation"),
          meta: { requiresAuth: true }
        },
        {
          path: "add-donation",
          name: "AddDonation",
          // component: AddDonation,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Donations/AddDonation"),
          meta: { requiresAuth: true }
        },
        {
          path: "donation-settings",
          name: "DonationSettings",
          // component: DonationSettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Donations/DonationSettings"),
          meta: { requiresAuth: true }
        },
        // Drivers
{
  path: "drivers",
  name: "Drivers",
  component: () =>
    import(/* webpackChunkName: "drivers" */ "./views/Back/Drivers/Drivers"),
  meta: { requiresAuth: true }
},
{
  path: "driver/:driver_id",
  name: "Driver",
  component: () =>
    import(/* webpackChunkName: "drivers" */ "./views/Back/Drivers/Driver"),
  meta: { requiresAuth: true }
},
{
  path: "add-driver",
  name: "AddDriver",
  component: () =>
    import(/* webpackChunkName: "drivers" */ "./views/Back/Drivers/AddDriver"),
  meta: { requiresAuth: true }
},
{
  path: "drivers-settings",
  name: "DriverSettings",
  component: () =>
    import(/* webpackChunkName: "drivers" */ "./views/Back/Drivers/DriverSettings"),
  meta: { requiresAuth: true }
},
// Vehicles
{
  path: "vehicles",
  name: "Vehicles",
  component: () =>
    import(/* webpackChunkName: "vehicles" */ "./views/Back/Vehicles/Vehicles"),
  meta: { requiresAuth: true }
},
{
  path: "vehicle/:vehicle_id",
  name: "Vehicle",
  component: () =>
    import(/* webpackChunkName: "vehicles" */ "./views/Back/Vehicles/Vehicle"),
  meta: { requiresAuth: true }
},
{
  path: "add-vehicle",
  name: "AddVehicle",
  component: () =>
    import(/* webpackChunkName: "vehicles" */ "./views/Back/Vehicles/AddVehicle"),
  meta: { requiresAuth: true }
},
{
  path: "vehicles-settings",
  name: "VehicleSettings",
  component: () =>
    import(/* webpackChunkName: "vehicles" */ "./views/Back/Vehicles/VehicleSettings"),
  meta: { requiresAuth: true }
},
        // Reports
        {
          path: "csv",
          name: "CSV",
          // component: CSV,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Reports/CSV"),
          meta: { requiresAuth: true }
        },
        {
          path: "obts-charts",
          name: "Charts",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Reports/Charts"),
          meta: { requiresAuth: true }
        },
        {
          path: "obts-volumes",
          name: "Volume",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Reports/Volume"),
          meta: { requiresAuth: true }
        },
        {
          path: "booking-reports",
          name: "BookingsReport",
          // component: BookingsReport,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Reports/BookingsReport"),
          meta: { requiresAuth: true }
        },
        {
          path: "currency-reports",
          name: "CurrencyReport",
          // component: CurrencyReport,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Reports/CurrencyReport"),
          meta: { requiresAuth: true }
        },
        {
          path: "payment-reports",
          name: "PaymentsReport",
          // component: PaymentsReport,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Reports/PaymentsReport"),
          meta: { requiresAuth: true }
        },
        {
          path: "visitors-reports",
          name: "VisitorsReport",
          // component: VisitorsReport,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Reports/VisitorsReport"),
          meta: { requiresAuth: true }
        },
        // Taxes
        {
          path: "catering-levy-history",
          name: "CateringLevyHistory",
          // component: CateringLevyHistory,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Taxes/CateringLevyHistory"),
          meta: { requiresAuth: true }
        },
        {
          path: "update-catering-levy",
          name: "UpdateCateringLevy",
          // component: UpdateCateringLevy,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Taxes/UpdateCateringLevy"),
          meta: { requiresAuth: true }
        },
        {
          path: "update-vat",
          name: "UpdateVat",
          // component: UpdateVat,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Taxes/UpdateVat"),
          meta: { requiresAuth: true }
        },
        {
          path: "vat-history",
          name: "VatHistory",
          // component: VatHistory,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Taxes/VatHistory"),
          meta: { requiresAuth: true }
        },
        // Currency
        {
          path: "currency-history",
          name: "CurrencyHistory",
          // component: CurrencyHistory,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Currency/CurrencyHistory"),
          meta: { requiresAuth: true }
        },
        {
          path: "add-currency",
          name: "AddCurrency",
          // component: AddCurrency,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Currency/AddCurrency"),
          meta: { requiresAuth: true }
        },
        {
          path: "update-currency",
          name: "UpdateCurrency",
          // component: UpdateCurrency,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Currency/UpdateCurrency"),
          meta: { requiresAuth: true }
        },
        // Facilities
        {
          path: "m-facility/:facility_id",
          name: "Facility",
          // component: Facility,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Facilities/Facility"),
          meta: { requiresAuth: true }
        },
        {
          path: "new-facility",
          name: "NewFacility",
          // component: NewFacility,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Facilities/NewFacility"),
          meta: { requiresAuth: true }
        },
        {
          path: "edit-facility/:facility_id",
          name: "EditFacility",
          // component: NewFacility,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Facilities/NewFacility"),
          meta: { requiresAuth: true }
        },
        {
          path: "facilities",
          name: "Facilities",
          // component: Facilities,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Facilities/Facilities"),
          meta: { requiresAuth: true }
        },
        {
          path: "active-facilities",
          name: "ActiveFacilities",
          // component: Facilities,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Facilities/Facilities"),
          meta: { requiresAuth: true }
        },
        {
          path: "inactive-facilities",
          name: "InactiveFacilities",
          // component: InactiveFacilities,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Facilities/InactiveFacilities"),
          meta: { requiresAuth: true }
        },
        {
          path: "facilities-settings",
          name: "FacilitySettings",
          // component: FacilitySettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Facilities/FacilitiesSettings"),
          meta: { requiresAuth: true }
        },
        // Partners
        {
          path: "partner/:partner_id",
          name: "Partner",
          // component: Partner,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Partners/Partner"),
          meta: { requiresAuth: true }
        },
        {
          path: "edit-partner/:partner_id",
          name: "EditPartner",
          // component: NewPartner,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Partners/NewPartner"),
          meta: { requiresAuth: true }
        },
        {
          path: "new-partner",
          name: "NewPartner",
          // component: NewPartner,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Partners/NewPartner"),
          meta: { requiresAuth: true }
        },
        {
          path: "partners",
          name: "Partners",
          // component: Partners,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Partners/Partners"),
          meta: { requiresAuth: true }
        },
        {
          path: "partner-settings",
          name: "PartnerSettings",
          // component: PartnerSettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Partners/PartnerSettings"),
          meta: { requiresAuth: true }
        },
        {
          path: "partner-bookings",
          name: "PartnerBookings",
          // component: PartnerBookings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Partners/PartnerBookings"),
          meta: { requiresAuth: true }
        },
        // Booking
        {
          path: "npartner-booking",
          name: "NewPartnerBooking",
          // component: NewPartnerBooking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/NewPartnerBooking"),
          meta: { requiresAuth: true }
        },
        {
          path: "edit-booking/:booking_id",
          name: "EditBooking",
          // component: EditBooking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/EditBooking"),
          meta: { requiresAuth: true }
        },

        {
          path: "new-booking",
          name: "NewBooking",
          // component: NewBooking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/New"),
          meta: { requiresAuth: true }
        },

        {
         path: "my-bookings",
         name: "MyBookings",
         component: () =>
          import("./views/Back/Bookings/MyBookingsHistory"),
         meta: { requiresAuth: true }
        },
        {
  path: "guest-checkout",
  name: "GuestCheckout",
  component: () =>
    import(/* webpackChunkName: "guest-checkout" */ "./views/Back/Guests/GuestCheckout"),
  meta: { requiresAuth: true }
},

{
  path: "guest-payment/:booking_id",
  name: "GuestPaymentInformation",
  component: () => import("./views/Back/Guests/GuestPaymentInformation.vue"),
  meta: { requiresAuth: true, payment: true }
},
  {
    path: "guest-success/:booking_id",
    name: "GuestSuccess",
    component: () => import("./views/Back/Guests/GuestSuccess.vue"),
    meta: { requiresAuth: true }
  },
        {
         path: "new-guest-booking",
         name: "MakeGuestBooking",
         component: () =>
          import("./views/Back/Bookings/NewGuestBooking"),
         meta: { requiresAuth: true }
        },

                {
         path: "rebook",
         name: "Rebook",
         component: () =>
          import("./views/Back/Bookings/Rebook"),
         meta: { requiresAuth: true }
        },

        {
          path: "incomplete-gate-tickets",
          name: "GatePasses",
          // component: GateTickets,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/GateTickets"),
          meta: { requiresAuth: true }
        },
        {
          path: "receipt/:booking_id",
          name: "Receipt",
          // component: Receipt,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/Receipt"),
          meta: { requiresAuth: true }
        },
        {
          path: "p-receipt/:booking_id",
          name: "PartnerReceipt",
          // component: PartnerReceipt,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/PartnerReceipt"),
          meta: { requiresAuth: true }
        },
        {
          path: "receipt-payment/:booking_id",
          name: "GatePayment",
          // component: GatePayment,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/GatePayment"),
          meta: { requiresAuth: true }
        },
        {
          path: "receipt-checkin/:booking_id",
          name: "Checkin",
          // component: Checkin,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/CheckIn"),
          meta: { requiresAuth: true }
        },
        {
          path: "bookings",
          name: "Bookings",
          // component: Bookings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/Bookings"),
          meta: { requiresAuth: true }
        },
        {
          path: "search-results",
          name: "SearchResults",
          // component: Bookings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/Bookings"),
          meta: { requiresAuth: true }
        },
        {
          path: "booking/:booking_id",
          name: "Booking",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/Booking"),
          meta: { requiresAuth: true }
        },
        {
          path: "bookings/inspection",
          name: "BookingsInspection",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingsInspection"),
          meta: { requiresAuth: true }
        },
        {
          path: "booking/inspection/:booking_id",
          name: "BookingInspection",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingInspection"),
          meta: { requiresAuth: true }
        },
        {
          path: "bookings-unticketed-alerts",
          name: "BookingUnticketedAlert",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingUnticketedAlert"),
          // meta: { requiresAuth: true }
        },
        {
          path: "bookings-alerts",
          name: "BookingsAlert",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingsAlert"),
          // meta: { requiresAuth: true }
        },
        {
          path: "bookings-residency-proof",
          name: "ResidencyProof",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingResidencyProof"),
          // meta: { requiresAuth: true }
        },
        {
          path: "booking/update-alert/:note_id",
          name: "ViewUpdateAlert",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/ViewUpdateAlert"),
          // meta: { requiresAuth: true }
        },
        {
          path: "bookings/ban",
          name: "BookingsBan",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingsBan"),
          meta: { requiresAuth: true }
        },
        {
          path: "bookings/ban/:booking_ban_id",
          name: "ViewBookingBan",
          // component: Booking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingBan"),
          // meta: { requiresAuth: true }
        },
        {
          path: "new-group-booking",
          name: "GroupBooking",
          // component: GroupBooking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/GroupBooking"),
          meta: { requiresAuth: true }
        },
        {
          path: "booking-settings",
          name: "BookingSettings",
          // component: BookingSettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/BookingSettings"),
          meta: { requiresAuth: true }
        },
        {
          path: "confirmed-bookings",
          name: "ConfirmedBookings",
          // component: ConfirmedBookings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/Confirmed"),
          meta: { requiresAuth: true }
        },
        {
          path: "un-confirmed-bookings",
          name: "UnconfirmedBookings",
          // component: UnconfirmedBookings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/Unconfirmed"),
          meta: { requiresAuth: true }
        },
        {
          path: "find-booking",
          name: "FindBooking",
          // component: FindBooking,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/FindBooking"),
          meta: { requiresAuth: true }
        },
        {
          path: "checked-in",
          name: "CheckedIn",
          // component: CheckedIn,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/CheckedIn"),
          meta: { requiresAuth: true }
        },
        {
          path: "checked-out",
          name: "CheckedOut",
          // component: CheckedOut,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Bookings/CheckedOut"),
          meta: { requiresAuth: true }
        },
        // Inventory
        {
          path: "single-inventory/:inventory_id",
          name: "SingleInventory",
          // component: SingleInventory,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/SingleInventory"),
          meta: { requiresAuth: true }
        },
        {
          path: "new-inventory",
          name: "NewInventory",
          // component: NewInventory,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/NewInventory"),
          meta: { requiresAuth: true }
        },
        {
          path: "edit-inventory/:inventory_id",
          name: "EditInventory",
          // component: NewInventory,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/NewInventory"),
          meta: { requiresAuth: true }
        },
        {
          path: "inventory",
          name: "Inventory",
          // component: Inventories,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/Inventory"),
          meta: { requiresAuth: true }
        },
        {
          path: "active-inventory",
          name: "ActiveInventory",
          // component: Inventories,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/Inventory"),
          meta: { requiresAuth: true }
        },
        {
          path: "inactive-inventory",
          name: "InactiveInventory",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/InactiveInventory"),
          // component: InactiveInventory,
          meta: { requiresAuth: true }
        },
        {
          path: "availability",
          name: "Availability",
          // component: Availability,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/Availability"),
          meta: { requiresAuth: true }
        },
        {
          path: "inventory-setting",
          name: "InventorySettings",
          // component: InventorySettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Inventory/InventorySettings"),
          meta: { requiresAuth: true }
        },
        // Membership
        {
          path: "new-membership",
          name: "NewMember",
          // component: NewMember,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Membership/NewMember"),
          meta: { requiresAuth: true }
        },
        {
          path: "members",
          name: "Members",
          // component: Members,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Membership/Members"),
          meta: { requiresAuth: true }
        },
        {
          path: "member/:member_id",
          name: "Member",
          // component: Member,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Membership/Member"),
          meta: { requiresAuth: true }
        },
        {
          path: "corporate/member/:member_id",
          name: "Corporate",
          // component: Member,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Membership/Corporate"),
          meta: { requiresAuth: false }
        },
        {
          path: "membership-settings",
          name: "MembershipSettings",
          // component: MembershipSettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Membership/MembershipSettings"),
          meta: { requiresAuth: true }
        },
        {
          path: "CorporateMember",
          name: "CorporateMember",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Membership/CorporateMember"),
          meta: { requiresAuth: true }
        },
        // Visitors
        {
          path: "new-visitor",
          name: "NewVisitor",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Visitors/NewVisitor"),
          meta: { requiresAuth: true }
        },
        {
          path: "visitors",
          name: "Visitors",
          // component: Visitors,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Visitors/Visitors"),
          meta: { requiresAuth: true }
        },
        {
          path: "visitor/:visitor_id",
          name: "Visitor",
          // component: Visitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Visitors/Visitor"),
          meta: { requiresAuth: true }
        },
        {
          path: "visitors-history",
          name: "VisitorHistory",
          // component: VisitorHistory,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Visitors/VisitorHistory"),
          meta: { requiresAuth: true }
        },
        {
          path: "visitors-settings",
          name: "VisitorSettings",
          // component: VisitorSettings,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Visitors/VisitorSettings"),
          meta: { requiresAuth: true }
        },
        {
          path: "edit-visitor/:visitor_id",
          name: "EditVisitor",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Visitors/NewVisitor"),
          meta: { requiresAuth: true }
        },
        
        // Wallet (Guests Portal)
{
  path: "my-wallet",
  name: "MyWallet",
  component: () =>
    import(/* webpackChunkName: "wallet" */ "./views/Back/Wallet/MyWallet"),
  meta: { requiresAuth: true }
},
{
  path: "deposit-funds",
  name: "DepositFunds",
  component: () =>
    import(/* webpackChunkName: "wallet" */ "./views/Back/Wallet/DepositFunds"),
  meta: { requiresAuth: true }
},
{
  path: "transactions",
  name: "Transactions",
  component: () =>
    import(/* webpackChunkName: "wallet" */ "./views/Back/Wallet/Transactions"),
  meta: { requiresAuth: true }
},


        // Logs
        // {
        //   path: "all-logs",
        //   name: "AllLogs",
        //   // component: NewVisitor,
        //   component: () =>
        //     import(/* webpackChunkName: "about" */ "./views/Back/Logs/AllLogs"),
        //   meta: { requiresAuth: true }
        // },
        {
          path: "system-logs",
          name: "SystemWideLogs",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Logs/SystemWideLogs"),
          meta: { requiresAuth: true }
        },
        {
          path: "auth-logs",
          name: "AuthLogs",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Logs/AuthLogs"),
          meta: { requiresAuth: true }
        },
        {
          path: "feature-tracker-logs",
          name: "FeatureTrackerLogs",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Logs/FeatureTrackerLogs"),
          meta: { requiresAuth: true }
        },
        {
          path: "password-reset-logs",
          name: "PasswordResetLogs",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Logs/PasswordResetLogs"),
          meta: { requiresAuth: true }
        },
        // Promo Codes
        {
          path: "generate-promo-codes",
          name: "GeneratePromoCodes",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/PromoCodes/GeneratePromoCodes"),
          meta: { requiresAuth: true }
        },
        {
          path: "promo-code/:code_id",
          name: "PromoCode",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/PromoCodes/PromoCode"),
          meta: { requiresAuth: true }
        },
        {
          path: "e-promo-code/:promo_code_id",
          name: "PromoCodeEdit",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/PromoCodes/EditPromoCode"),
          meta: { requiresAuth: true }
        },
        {
          path: "u-promo-code/:promo_code_id",
          name: "PromoCodeUsage",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/PromoCodes/PromoCodeUsage"),
          meta: { requiresAuth: true }
        },
        {
          path: "promo-codes",
          name: "PromoCodes",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/PromoCodes/PromoCodes"),
          meta: { requiresAuth: true }
        },
        {
          path: "promo-code-types",
          name: "PromoCodeTypes",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/PromoCodes/PromoCodeTypes"),
          meta: { requiresAuth: true }
        },
        // Finance
        {
          path: "tickets",
          name: "Tickets",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Finance/Tickets"),
          meta: { requiresAuth: true }
        },
        {
          path: "obts-invoice",
          name: "ObtsInvoice",
          meta: { requiresAuth: true }
        },
        {
          path: "payment-gateways",
          name: "PaymentGateways",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Finance/PaymentGateways"),
          meta: { requiresAuth: true }
        },
        {
          path: "payments",
          name: "Payments",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Finance/Payments"),
          meta: { requiresAuth: true }
        },
        {
          path: "passes",
          name: "Passes",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Finance/Passes"),
          meta: { requiresAuth: true }
        },
        {
          path: "batchfiles",
          name: "Batchfile",
          // component: NewVisitor,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Finance/Batchfile"),
          meta: { requiresAuth: true }
        },
        {
          path: "Changelog",
          name: "Changelog",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Changelog/Changelog.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "new-changelog",
          name: "NewChangeLog",
          // component: NewChangeLog,
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Back/Changelog/NewChangeLog.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "postpone-booking/:booking_id",
          name: "PostponeBooking",
          component: PostponeBooking
          // meta: { payment: true }
        }
      ]
    }
  ]
});
